import T from '../types';

const cacheSuggest = (data, mode, id) => ({
  type: T.SUGGEST_CACHE,
  data,
  mode,
  id,
});

export default cacheSuggest;
